import React, { Component } from "react";
import TimeInput from "./TimeInput";
import {throttle} from "lodash";

import UpIcon from "./img/Up.svg"
import DownIcon from "./img/Down.svg"
import DotIcon from "./img/Dot.svg"

import "./style.scss";

import {
  start,
  drag,
  end,
  setDragImage,
  //getTarget,
  getTransform
} from "./DragFunctions"

export class ConstantStep extends Component {

  constructor(props) {
    super(props);

    this.state = {
      maxHeight: 0,
      offset: null,
      temp: this.props.props.temp,
      duration: this.props.props.duration
    };

    this.dragarea = React.createRef();
    this.dragToggle = React.createRef();
  }

  setOffset = () => {

    let offset = this.state.maxHeight - getTransform(this.dragToggle.current).translateY

    this.setState({
      offset: offset,
      temp: this.convertOffsetToTemp(offset)
    })
  }

  setStepDuration = (duration, index) => {
    this.setState({
      duration: duration
    }, ()=>this.props.updateSequenceTime({}))
  }

  onDragStart = (e) => {
    setDragImage(e)
    start(e, e.target)
  }

  onDragOver = throttle((e, index) => {
     e.preventDefault();
     drag(e, this.dragToggle.current, this.state.maxHeight);
     this.setOffset()
   }, 10);

  onDrop = (e, index) => {
    e.preventDefault()

    end(e, this.dragToggle.current)
    this.setOffset()
    this.props.updateSequenceTemp({})
  }

  setMaxHeight = () => {
    let height = (this.dragarea.current.getBoundingClientRect().height - 52)

    this.setState({
      maxHeight: height
    }, ()=>{
      this.setState({
        offset: this.convertTempToOffset(this.props.props.temp)
      })
    })
  }

  convertOffsetToTemp = (offset) => {

    let percentage = offset / this.state.maxHeight
    return Math.round(95 * percentage);
  }

  convertTempToOffset = (temp) => {

    let percentage = temp / 95;
    return (this.state.maxHeight * (percentage));
  }

  save = () => {
    let temp = this.convertOffsetToTemp(this.state.offset);
    let step = this.props.sequence[this.props.props.id - 1];

    step.temp = temp;
    step.duration = this.state.duration;
    this.props.updateSequence({
      id: this.props.id,
      index: this.props.props.id - 1,
      item: step
    });
  }

  moveUp = () => {
    let temp = this.state.temp + 1;

    if(temp >= 0 && temp <= 95){
      this.setState({
        temp: temp,
        offset: this.convertTempToOffset(temp)
      }, () => {
        let step = this.props.sequence[this.props.props.id - 1];

        step.temp = this.state.temp;
        step.duration = this.state.duration;
        this.props.updateSequence({
          id: this.props.id,
          index: this.props.props.id - 1,
          item: step
        });
      })
    }
  }

  moveDown = () => {
    let temp = this.state.temp - 1;

    if(temp >= 0 && temp <= 95){
      this.setState({
        temp: temp,
        offset: this.convertTempToOffset(temp)
      }, () => {
        let step = this.props.sequence[this.props.props.id - 1];

        step.temp = this.state.temp;
        step.duration = this.state.duration;
        this.props.updateSequence({
          id: this.props.id,
          index: this.props.props.id - 1,
          item: step
        });
      })
    }
  }

  onChange = (e) => {
    if(e.target.value >= 0 && e.target.value <= 95){
      this.setState({
        temp: e.target.value,
        offset: this.convertTempToOffset(e.target.value)
      })
    }
  }

  onBlur = () => {
    let step = this.props.sequence[this.props.props.id - 1];

    step.temp = this.state.temp;
    step.duration = this.state.duration;
    this.props.updateSequence({
      id: this.props.id,
      index: this.props.props.id - 1,
      item: step
    });
  }

  componentDidMount() {
    // Resize the scene and attach the resize method to the window resize event
    this.setMaxHeight()
    window.addEventListener("resize", this.setMaxHeight);

    this.setState({
      offset: this.convertTempToOffset(this.props.props.temp)
    })
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.setMaxHeight);
  }
  componentDidUpdate(prevProps, prevState){
    if(
      (
        this.state.temp !== prevState.temp ||
        this.state.duration !== prevState.duration
      )// && !this.props.saved
    ){
      this.save()
      this.props.setSaved({
        id: this.props.id,
        saved: true
      })
    }
    if(
      prevState.offset !== this.state.offset
     ){
      this.dragToggle.current.style.transform = "translate3d(0px, "+(this.state.maxHeight - this.state.offset)+"px, 0px) rotateZ(0deg)"
    }
  }

  render() {
    return (
      <div className="constant-step" style={{display: "flex", flexDirection: "column"}}>
        <div className="step-header">
          <div className="step-label">
            {this.props.props.id}
          </div>
        </div>
        <div
          className="step-drag-area"
          onDragStart={this.onDragStart}
          onDragOver={(e)=>{
            e.persist();
            this.onDragOver(e, this.props.props.id - 1);
          }}
          onDragEnd={(e)=> this.onDrop(e, this.props.props.id - 1)}
          ref={this.dragarea}
          >
          <div
            className="drag-item"
            draggable
            ref={this.dragToggle}
            style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)" }}
          >
            <div style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            }}>
              <div style={{
                display: "flex",
                flexDirection: "column"
              }}>
                <button
                  onClick={()=>this.moveUp()}
                  style={{
                    background: "none",
                    border: "none",
                    width: "10px",
                    height: "10px",
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer"
                  }}>
                    <img style={{
                      width: "100%",
                      height: "100%",
                      pointerEvents: "none"
                    }} src={UpIcon} alt="" />
                  </button>
                <button
                  style={{
                    background: "none",
                    border: "none",
                    width: "10px",
                    height: "10px",
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <img style={{
                      width: "6px",
                      height: "100%",
                      pointerEvents: "none"
                    }} src={DotIcon} alt="" /> 
                  </button>
                <button
                  onClick={()=>this.moveDown()}
                  style={{
                    background: "none",
                    border: "none",
                    width: "10px",
                    height: "10px",
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer"
                  }}>
                    <img style={{
                      width: "100%",
                      height: "100%",
                      pointerEvents: "none"
                    }} src={DownIcon} alt=""/>
                </button>
              </div>
              <input
                onChange={(e)=>this.onChange(e)}
                onBlur={()=>this.onBlur()}
                style={{width: "86px", height: "24px", marginRight: "3px"}}
                value={this.state.temp}
              />
              <label style={{pointerEvents: "none"}}>°C</label>
            </div>
          </div>
        </div>
        <div className="step-footer">
          <TimeInput
            value={this.state.duration}
            minValue={0}
            maxValue={362439}
            buttonIncrement={1}
            onChange={(duration)=>this.setStepDuration(duration, this.props.props.id - 1)}
          />
        </div>
      </div>
    )
  }
}
